// extracted by mini-css-extract-plugin
export default {"link":"social-link__link___IwsoT","imageSocialLink":"social-link__imageSocialLink___1EIZm"};